(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("0aqV5", function(module, exports) {

$parcel$export(module.exports, "dateClear", function () { return $0008180424956a49$export$4e263ecf9fabb476; });

var $dbdyf = parcelRequire("dbdyf");

var $4HMvE = parcelRequire("4HMvE");

const $0008180424956a49$var$dates = document.querySelectorAll(".f-date");
const $0008180424956a49$export$4e263ecf9fabb476 = (input)=>{
    const fp = input;
    console.log(fp);
};
$0008180424956a49$var$dates.forEach((date)=>{
    const input = date.querySelector(".f-date__input.flatpicker");
    if (!input) return;
    date.classList.remove("--native");
    input.type = "text";
    input.setAttribute("readonly", "");
    const flatpickerOptions = {
        enableTime: false,
        altInput: true,
        altFormat: "d.m.Y",
        locale: (0, $4HMvE.Czech),
        minDate: "today",
        mode: input.hasAttribute("data-range") ? "range" : "single"
    };
    (0, $dbdyf.default).l10ns.cs.rangeSeparator = " - ";
    (0, $dbdyf.default)(input, flatpickerOptions);
});

});

})();
//# sourceMappingURL=date-field.cf23c0aa.js.map
